import * as ko from "knockout";
import Guid from "./guid";
function InstructionAttachment() {
    var self = this;
    self.InstructionAttachmentId = ko.observable(Guid());
    self.InstructionId = ko.observable();
    self.Revision = ko.observable();
    self.Description = ko.observable();
    self.DeleteInRevision = ko.observable(null);
    self.dirtyExtender = {};
}
;
export default InstructionAttachment;